import styled from 'styled-components';

export const Container = styled.div`
	padding: 16px;

	& > .ant-card {
		margin: 12px 0;
	}
`;

export const FiltersContainer = styled.form`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const AvatarCell = styled.div`
	display: flex;
	align-items: center;

	& > .ant-typography {
		margin-left: 10px;
	}

	& .name {
		cursor: pointer;

		&:hover {
			color: var(--primary);
			text-decoration: underline;
		}
	}
`;

export const UpdateFormContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`;

export const UpdateAvatarContainer = styled.div`
	width: max-content;
	height: max-content;
	border-radius: 50%;
	position: relative;
	background: red;

	& > div.overlay {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		display: flex;
		position: absolute;
		top: 0;
		left: 0;
		align-items: center;
		justify-content: center;
		z-index: 20;
		cursor: pointer;

		& > span {
			opacity: 0.4;
			color: #fff;
		}

		&:hover {
			background: rgba(0, 0, 0, 0.4);

			& > span {
				opacity: 1;
			}
		}
	}
`;
